export default {
    EDITION_2019: 1,
    EDITION_2020: 2
};
